/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ImageType;

(function (ImageType) {
  ImageType["LOGO"] = "logo";
  ImageType["PROMO_BANNER"] = "promo_banner";
  ImageType["DEFAULT"] = "default";
})(ImageType || (ImageType = {}));